import { createSelector } from 'reselect';
import {
    RATE_ADJUSTMENT_FORM,
    BASE_PRICE_FORM,
    DEPENDENT_RATE_ADJUSTMENT_FORM,
    ATTRIBUTE_PRICE_ADJUSTMENT_FORM,
    OCCUPANCY_ADJUSTMENT_FORM,
    AGE_CATEGORY_ADJUSTMENT_FORM,
} from '../constants';
import { getSelectedProductId, getSelectedRateId } from './data';

export const getRateAdjustmentFormName = createSelector(
    getSelectedRateId,
    getSelectedProductId,
    (rateId, productId) => {
        if (rateId !== null) {
            return `${rateId}-${RATE_ADJUSTMENT_FORM}`;
        }
        return `${productId}-${RATE_ADJUSTMENT_FORM}`;
    }
);

export const getBasePriceFormName = createSelector(getSelectedRateId, getSelectedProductId, (rateId, productId) => {
    if (rateId !== null) {
        return `${rateId}-${BASE_PRICE_FORM}`;
    }
    return `${productId}-${BASE_PRICE_FORM}`;
});
export const getDependentRateAdjustmentFormName = createSelector(
    getSelectedRateId,
    (rateId) => `${rateId}-${DEPENDENT_RATE_ADJUSTMENT_FORM}`
);
export const getOccupancyAdjustmentFormName = createSelector(
    getSelectedRateId,
    (rateId) => `${rateId}-${OCCUPANCY_ADJUSTMENT_FORM}`
);
export const getAgeCategoryAdjustmentFormName = createSelector(
    getSelectedRateId,
    (rateId) => `${rateId}-${AGE_CATEGORY_ADJUSTMENT_FORM}`
);

export const getAttributePriceAdjustmentFormName = createSelector(
    getSelectedRateId,
    (rateId) => `${rateId}-${ATTRIBUTE_PRICE_ADJUSTMENT_FORM}`
);
